import { render, staticRenderFns } from "./DataTableActions.vue?vue&type=template&id=0ec38dfe&"
import script from "./DataTableActions.vue?vue&type=script&lang=js&"
export * from "./DataTableActions.vue?vue&type=script&lang=js&"
import style0 from "./DataTableActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports